module.exports = "<?php\n\nnamespace App;\n\nrequire __DIR__ . '/vendor/autoload.php';\n\nuse Symfony\\Component\\Process\\Process;\n\n$code = <<<JS\n1+1;\nJS;\n\n$embedded = '\"process.stdout.write(eval(\\''.$code.'\\').toString())\"';\n\n$process = new Process('node -e '.$embedded);\n\n$process->run();\n\necho('<html><body>');\n\necho('My program is: '.$embedded.'<br/>');\necho('Output: '.$process->getOutput().'<br/>');\n\necho('</body></html>');\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/first.php.txt
// module id = 444
// module chunks = 35783957827783